<app-spinner></app-spinner>
<div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" style="padding: 10px">
  <mat-card
    style="background-color: var(--lightbg1)"
    class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
  >
    <mat-card-header style="justify-content: center">
      <div style="margin-top: 1%"></div>
      <mat-card-title>
        <div class="backcontainer">
          <div class="Back" (click)="backtoApiManager()">
            <img
              src="assets/img/icons/shape-1.png"
              matTooltip="Back"
              matTooltipPosition="left"
            />
            <span> Back</span>
          </div>
        </div>
        <div class="headLabel">Response Mapping</div>
      </mat-card-title>
    </mat-card-header>

    <div class="col-sm-12 col-xs-12 col-md-8 col-lg-8">
      <mat-card
        style="margin-top: 10px; margin-bottom: 10px"
        class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
      >
        <mat-card-header>
          <mat-card-title>
            <div class="headLabel">Response Entities</div>
          </mat-card-title>
        </mat-card-header>

        <table
          mat-table
          matSort
          [dataSource]="dataSource"
          class="mat-elevation-z8"
          style="width: 100%"
        >
          <ng-container matColumnDef="apiResponseMappingId ">
            <th mat-header-cell *matHeaderCellDef>Id</th>
            <td mat-cell *matCellDef="let element">
              {{ element.apiMappingId }}
            </td>
          </ng-container>

          <ng-container matColumnDef="Sno">
            <th mat-header-cell *matHeaderCellDef>S.No</th>
            <td mat-cell *matCellDef="let element">
              {{ dataSource.filteredData.indexOf(element) + 1 }}
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>

          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef>Edit</th>
            <td
              mat-cell
              *matCellDef="let element"
              (click)="editResponseMapping(element.apiMappingId)"
              matTooltip="Edit"
              matTooltipPosition="left"
            >
              <img src="assets/img/icons/forma-1-copy-2.png " />
            </td>
          </ng-container>
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef>Delete</th>
            <td
              mat-cell
              *matCellDef="let element; let i = i; ndex"
              (click)="deleteResponseMapping(element.apiMappingId)"
              matTooltip="Delete"
              matTooltipPosition="left"
            >
              <img src="assets/img/icons/forma-1.png " />
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedcolumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedcolumns"></tr>
        </table>

        <mat-paginator
          #paginator
          [pageSizeOptions]="[10, 20, 100]"
          showFirstLastButtons
          [pageIndex]="pageIndex"
          [pageSize]="pageSize"
          (page)="handlePage($event)"
        ></mat-paginator>
        <!-- 	<div   style="float:left; margin-top: -6%;padding-left: 5px;">
        <div (click)="gotoResponseMappingForm()"
                mat-flat-button class="Rounded formbutton" >Add +</div>
        </div>	 -->
        <div style="float: left">
          <div
            (click)="gotoResponseMappingForm()"
            mat-flat-button
            class="Rounded formbutton pointer"
            matTooltip="Add"
            matTooltipPosition="below"
          >
            Add +
          </div>
        </div>
      </mat-card>
      <!--Parent Response-->
      <mat-card
        *ngIf="apiParentId != '0'"
        style="margin-top: 10px; margin-bottom: 10px"
        class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
      >
        <mat-card-header>
          <mat-card-title>
            <div class="headLabel">Parent Entities</div>
          </mat-card-title>
        </mat-card-header>
        <table
          mat-table
          matSort
          [dataSource]="parentDatasource"
          class="mat-elevation-z8"
          style="width: 100%"
        >
          <ng-container matColumnDef="Sno">
            <th mat-header-cell *matHeaderCellDef>S.No</th>
            <td mat-cell *matCellDef="let element">
              {{ parentDatasource.filteredData.indexOf(element) + 1 }}
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox
                style="text-overflow: inherit"
                (change)="onChange($event.checked, element.name)"
                [checked]="checkedAttribute(element.name)"
              ></mat-checkbox>
              {{ element.name }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="parentdisplayedcolumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: parentdisplayedcolumns"
          ></tr>
        </table>

        <mat-paginator
          #parentPaginator
          [pageSizeOptions]="[10, 20, 100]"
          showFirstLastButtons
          [pageIndex]="parentpageIndex"
          [pageSize]="parentpazesize"
          (page)="handlePageParent($event)"
        ></mat-paginator>
      </mat-card>

      <!--Pagiination-->

      <mat-card
        style="margin-top: 10px; margin-bottom: 10px"
        class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
      >
        <form [formGroup]="apiPagination" class="example-form">
          <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
              Pagination:
            </div>

            <div class="col-sm-12 col-xs-12 col-md-3 col-lg-3">
              <div class="color-switcher">
                <i class="colorswitcher-active" style="--size: 35px">on</i>
                <label class="switch">
                  <input
                    id="darkTheme"
                    type="checkbox"
                    formControlName="IsPagination"
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
            <div class="col-sm-12 col-xs-12 col-md-2 col-lg-2 flabel">
              Count:
            </div>

            <div class="col-sm-12 col-xs-12 col-md-3 col-lg-3">
              <mat-form-field
                appearance="outline"
                class="example-full-width"
                style="width: 100%"
              >
                <input
                  *ngIf="apiPagination.value.IsPagination"
                  matInput
                  formControlName="Count"
                  (keypress)="numberOnly($event)"
                />
                <input
                  *ngIf="!apiPagination.value.IsPagination"
                  matInput
                  [disabled]="true"
                  value="0"
                  (keypress)="numberOnly($event)"
                />
              </mat-form-field>
              <!--  <mat-error *ngIf="!apiResponseMapping.value.Name">Name is Required</mat-error> -->
            </div>
          </div>

          <!--Dynamic Parameter Begin  -->
          <mat-card
            class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
            formArrayName="Parameter"
          >
            <mat-label>
              Parameter
              <img
                style="padding-left: 10px; height: 25px; width: 35px"
                src="assets/img/icons/group-31.png "
                (click)="addParameter()"
              />
            </mat-label>
            <!-- loop throught units -->
            <div
              class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
              *ngFor="
                let parameter of apiPagination.get('Parameter')['controls'];
                let i = index
              "
            >
              <!-- row divider show for every nex row exclude if first row -->
              <!-- <mat-divider
                *ngIf="apiResponseMapping.controls.parameter.controls.length > 1 && i > 0">
            </mat-divider> -->
              <br />

              <!-- group name in this case row index -->

              <div [formGroupName]="i">
                <div
                  fxLayout="row"
                  fxLayout.xs="column"
                  fxLayoutWrap
                  fxLayoutGap="3.5%"
                  fxLayoutAlign="center"
                >
                  <mat-form-field
                    appearance="outline"
                    style="width: 30%; padding-right: 10px"
                  >
                    <mat-label>Key</mat-label>

                    <input matInput type="text" formControlName="Attribute" />
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    style="width: 30%; padding-right: 10px"
                  >
                    <mat-label></mat-label>
                    <mat-label>parameterType</mat-label>
                    <mat-select formControlName="parameterType">
                      <mat-option value="1">Hardcoded</mat-option>
                      <mat-option value="2"> Mapped </mat-option>
                      <mat-option value="3">Formula </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field
                    *ngIf="
                      this.apiPagination.value.Parameter[i].parameterType == 1
                    "
                    appearance="outline"
                    style="width: 30%"
                  >
                    <mat-label>Value</mat-label>
                    <input
                      matInput
                      placeholder="value"
                      type="text"
                      formControlName="AttributeMap"
                    />
                  </mat-form-field>

                  <mat-form-field
                    *ngIf="
                      this.apiPagination.value.Parameter[i].parameterType == 3
                    "
                    appearance="outline"
                    style="width: 30%"
                  >
                    <mat-label>Value</mat-label>
                    <textarea
                      matInput
                      placeholder="value"
                      formControlName="AttributeMap"
                    ></textarea>
                  </mat-form-field>

                  <mat-form-field
                    *ngIf="!this.apiPagination.value.Parameter[i].parameterType"
                    appearance="outline"
                    style="width: 30%"
                  >
                    <mat-label>Value</mat-label>
                    <input
                      matInput
                      placeholder="value"
                      type="text"
                      formControlName="AttributeMap"
                    />
                  </mat-form-field>

                  <mat-form-field
                    *ngIf="
                      this.apiPagination.value.Parameter[i].parameterType == 2
                    "
                    appearance="outline"
                    style="width: 30%; padding-right: 10px"
                  >
                    <mat-label></mat-label> <mat-label>Value</mat-label>

                    <mat-select formControlName="AttributeMap">
                      <mat-option
                        *ngFor="let dattr of apiDynamicAttribue"
                        [value]="dattr.name"
                      >
                        {{ dattr.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <!-- <mat-checkbox [checked]="this.apiResponseMapping.controls['parameter'].value[i].isPositional === true"  formControlName="isPositional" checked="{{this.apiResponseMapping.controls['parameter'].value[i].isPositional}}"  (change)="onChange($event, i, apiResponseMapping.controls.parameter.controls)"   style="width:10%;padding-right: 10px;padding-left: 10px">
                    </mat-checkbox> -->

                  <img
                    style="padding-left: 6px; padding-bottom: 10px"
                    (click)="removeParameter(i)"
                    src="assets/img/icons/forma-1.png"
                  />
                </div>
              </div>
            </div>
          </mat-card>
          <!--Dynamic Parameter End  -->
          <div class="col-sm-6 col-xs-6 col-md-2 col-lg-2">
            <div class="col-sm-6 col-xs-6 col-md-6 col-lg-6"></div>
            <button
              [disabled]="!apiPagination.valid"
              class="col-sm-2 col-xs-2 col-md-2 col-lg-2 btn"
              mat-flat-button
              style="width: 100%"
              (click)="addApiPagination()"
            >
              Add
            </button>
          </div>
        </form>
      </mat-card>
      <!--Pagination End-->
    </div>

    <div class="col-sm-12 col-xs-12 col-md-4 col-lg-4">
      <mat-card
        style="
          background-color: var(--lightbg2);
          margin-top: 10px;
          min-height: 80vh;
        "
        class="col-sm-12 col-xs-12 col-md-12 col-lg-12"
      >
        <div class="loader">
          <img *ngIf="loader" src="assets/img/spinner.svg" />
        </div>
        <!-- Spinner End -->

        <div *ngIf="apiResponseData">
          <pre style="height: 80vh">			{{ apiResponseData | json }}</pre>
        </div>
      </mat-card>
    </div>
  </mat-card>
</div>
